var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hamburger",class:{ 'hamburger--close': _vm.menuVisible }},[_c('span',{staticClass:"hamburger__bar hamburger__bar--top"}),_c('span',{staticClass:"hamburger__bar hamburger__bar--middle"}),_c('span',{staticClass:"hamburger__bar hamburger__bar--bottom"})])
}
var staticRenderFns = []

export { render, staticRenderFns }